import { render, staticRenderFns } from "./Bahn1WichtigsteImpulse.vue?vue&type=template&id=85288688&scoped=true&"
import script from "./Bahn1WichtigsteImpulse.vue?vue&type=script&lang=js&"
export * from "./Bahn1WichtigsteImpulse.vue?vue&type=script&lang=js&"
import style0 from "./Bahn1WichtigsteImpulse.vue?vue&type=style&index=0&id=85288688&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85288688",
  null
  
)

export default component.exports